// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg aria-hidden=%27true%27 focusable=%27false%27 data-prefix=%27fas%27 data-icon=%27play%27 class=%27svg-inline--fa fa-play fa-w-14%27 role=%27img%27 xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 448 512%27><path fill=%27%23fff%27 d=%27M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z%27></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --aiiif-main-color: #cd171b;
}


.vjs-theme-forest {
  --vjs-theme-forest--primary: #fff;
  --vjs-theme-forest--secondary: var(--aiiif-main-color)
}

.aiiif-video-player .vjs-theme-forest.vjs-big-play-button:focus, .aiiif-video-player .vjs-theme-forest:hover .vjs-big-play-button {
  background:  var(--aiiif-main-color) no-repeat 20px center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 40%;
  opacity: 1;
}

.aiiif-video-player.vjs-theme-forest .vjs-big-play-button {
  width: 56px;
  height: 56px;
  background: var(--aiiif-main-color)no-repeat 20px center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 40%;
  border-radius: 40px;
  border: none;
  top: 50%;
  left: 50%;
  opacity: 1;
  margin-top: -44px;
  margin-left: -44px;
}

.vjs-theme-forest .vjs-big-play-button .vjs-icon-placeholder {
  display: none
}

.vjs-theme-forest .vjs-button > .vjs-icon-placeholder:before {
  line-height: 1.55
}

.vjs-theme-forest .vjs-control:not(.vjs-disabled):not(.vjs-time-control):hover {
  color: var(--vjs-theme-forest--primary);
  text-shadow: var(--vjs-theme-forest--secondary) 1px 0 10px
}

.vjs-theme-forest .vjs-control-bar {
  background: none;
  margin-bottom: 1em;
  padding-left: 1em;
  padding-right: 1em
}

.vjs-theme-forest .vjs-play-control {
  font-size: .8em
}

.vjs-theme-forest .vjs-play-control .vjs-icon-placeholder:before {
  background-color: var(--vjs-theme-forest--secondary);
  height: 1.5em;
  width: 1.5em;
  margin-top: .2em;
  border-radius: 1em;
  color: var(--vjs-theme-forest--primary)
}

.vjs-theme-forest .vjs-play-control:hover .vjs-icon-placeholder:before {
  background-color: var(--vjs-theme-forest--primary);
  color: var(--vjs-theme-forest--secondary)
}

.vjs-theme-forest .vjs-mute-control {
  display: none
}

.vjs-theme-forest .vjs-volume-panel {
  margin-left: .5em;
  margin-right: .5em;
  padding-top: .3em
}

.vjs-theme-forest .vjs-volume-bar.vjs-slider-horizontal, .vjs-theme-forest .vjs-volume-panel, .vjs-theme-forest .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .vjs-theme-forest .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal, .vjs-theme-forest .vjs-volume-panel:hover, .vjs-theme-forest .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-horizontal {
  width: 3em
}

.vjs-theme-forest .vjs-volume-level:before {
  font-size: 1em
}

.vjs-theme-forest .vjs-volume-panel .vjs-volume-control {
  opacity: 1;
  width: 100%;
  height: 100%
}

.vjs-theme-forest .vjs-volume-bar {
  background-color: transparent;
  margin: 0
}

.vjs-theme-forest .vjs-slider-horizontal .vjs-volume-level {
  height: 100%
}

.vjs-theme-forest .vjs-volume-bar.vjs-slider-horizontal {
  margin-top: 0;
  margin-bottom: 0;
  height: 100%
}

.vjs-theme-forest .vjs-volume-bar:before {
  content: "";
  z-index: 0;
  width: 0;
  height: 0;
  position: absolute;
  top: 0;
  left: 0;
  border-left: 3em solid transparent;
  border-bottom: 2em solid var(--vjs-theme-forest--primary);
  border-right: 0 solid transparent;
  border-top: 0 solid transparent
}

.vjs-theme-forest .vjs-volume-level {
  overflow: hidden;
  background-color: transparent
}

.vjs-theme-forest .vjs-volume-level:before {
  content: "";
  z-index: 1;
  width: 0;
  height: 0;
  position: absolute;
  top: 0;
  left: 0;
  border-left: 3em solid transparent;
  border-bottom: 2em solid var(--vjs-theme-forest--secondary);
  border-right: 0 solid transparent;
  border-top: 0 solid transparent
}

.vjs-theme-forest .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 1em
}

.vjs-theme-forest .vjs-play-progress:before {
  display: none
}

.vjs-theme-forest .vjs-progress-holder {
  border-radius: .2em;
  height: .5em;
  margin: 0
}

.vjs-theme-forest .vjs-load-progress, .vjs-theme-forest .vjs-load-progress div, .vjs-theme-forest .vjs-play-progress {
  border-radius: .2em
}

.video-js .vjs-time-control {
  display: block;
}
.video-js .vjs-remaining-time {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/viewer/media/vjsForest.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,iCAAiC;EACjC;AACF;;AAEA;EACE,0DAA0D;EAC1D,yDAA8X;EAC9X,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wDAAwD;EACxD,yDAA8X;EAC9X,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uCAAuC;EACvC;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oDAAoD;EACpD,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE,kDAAkD;EAClD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,yDAAyD;EACzD,iCAAiC;EACjC;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,2DAA2D;EAC3D,iCAAiC;EACjC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf","sourcesContent":[":root {\n  --aiiif-main-color: #cd171b;\n}\n\n\n.vjs-theme-forest {\n  --vjs-theme-forest--primary: #fff;\n  --vjs-theme-forest--secondary: var(--aiiif-main-color)\n}\n\n.aiiif-video-player .vjs-theme-forest.vjs-big-play-button:focus, .aiiif-video-player .vjs-theme-forest:hover .vjs-big-play-button {\n  background:  var(--aiiif-main-color) no-repeat 20px center;\n  background-image: url(\"data:image/svg+xml;utf8,<svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='play' class='svg-inline--fa fa-play fa-w-14' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path fill='%23fff' d='M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z'></path></svg>\");\n  background-size: 40%;\n  opacity: 1;\n}\n\n.aiiif-video-player.vjs-theme-forest .vjs-big-play-button {\n  width: 56px;\n  height: 56px;\n  background: var(--aiiif-main-color)no-repeat 20px center;\n  background-image: url(\"data:image/svg+xml;utf8,<svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='play' class='svg-inline--fa fa-play fa-w-14' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path fill='%23fff' d='M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z'></path></svg>\");\n  background-size: 40%;\n  border-radius: 40px;\n  border: none;\n  top: 50%;\n  left: 50%;\n  opacity: 1;\n  margin-top: -44px;\n  margin-left: -44px;\n}\n\n.vjs-theme-forest .vjs-big-play-button .vjs-icon-placeholder {\n  display: none\n}\n\n.vjs-theme-forest .vjs-button > .vjs-icon-placeholder:before {\n  line-height: 1.55\n}\n\n.vjs-theme-forest .vjs-control:not(.vjs-disabled):not(.vjs-time-control):hover {\n  color: var(--vjs-theme-forest--primary);\n  text-shadow: var(--vjs-theme-forest--secondary) 1px 0 10px\n}\n\n.vjs-theme-forest .vjs-control-bar {\n  background: none;\n  margin-bottom: 1em;\n  padding-left: 1em;\n  padding-right: 1em\n}\n\n.vjs-theme-forest .vjs-play-control {\n  font-size: .8em\n}\n\n.vjs-theme-forest .vjs-play-control .vjs-icon-placeholder:before {\n  background-color: var(--vjs-theme-forest--secondary);\n  height: 1.5em;\n  width: 1.5em;\n  margin-top: .2em;\n  border-radius: 1em;\n  color: var(--vjs-theme-forest--primary)\n}\n\n.vjs-theme-forest .vjs-play-control:hover .vjs-icon-placeholder:before {\n  background-color: var(--vjs-theme-forest--primary);\n  color: var(--vjs-theme-forest--secondary)\n}\n\n.vjs-theme-forest .vjs-mute-control {\n  display: none\n}\n\n.vjs-theme-forest .vjs-volume-panel {\n  margin-left: .5em;\n  margin-right: .5em;\n  padding-top: .3em\n}\n\n.vjs-theme-forest .vjs-volume-bar.vjs-slider-horizontal, .vjs-theme-forest .vjs-volume-panel, .vjs-theme-forest .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .vjs-theme-forest .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal, .vjs-theme-forest .vjs-volume-panel:hover, .vjs-theme-forest .vjs-volume-panel:hover .vjs-volume-control.vjs-volume-horizontal {\n  width: 3em\n}\n\n.vjs-theme-forest .vjs-volume-level:before {\n  font-size: 1em\n}\n\n.vjs-theme-forest .vjs-volume-panel .vjs-volume-control {\n  opacity: 1;\n  width: 100%;\n  height: 100%\n}\n\n.vjs-theme-forest .vjs-volume-bar {\n  background-color: transparent;\n  margin: 0\n}\n\n.vjs-theme-forest .vjs-slider-horizontal .vjs-volume-level {\n  height: 100%\n}\n\n.vjs-theme-forest .vjs-volume-bar.vjs-slider-horizontal {\n  margin-top: 0;\n  margin-bottom: 0;\n  height: 100%\n}\n\n.vjs-theme-forest .vjs-volume-bar:before {\n  content: \"\";\n  z-index: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-left: 3em solid transparent;\n  border-bottom: 2em solid var(--vjs-theme-forest--primary);\n  border-right: 0 solid transparent;\n  border-top: 0 solid transparent\n}\n\n.vjs-theme-forest .vjs-volume-level {\n  overflow: hidden;\n  background-color: transparent\n}\n\n.vjs-theme-forest .vjs-volume-level:before {\n  content: \"\";\n  z-index: 1;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-left: 3em solid transparent;\n  border-bottom: 2em solid var(--vjs-theme-forest--secondary);\n  border-right: 0 solid transparent;\n  border-top: 0 solid transparent\n}\n\n.vjs-theme-forest .vjs-progress-control:hover .vjs-progress-holder {\n  font-size: 1em\n}\n\n.vjs-theme-forest .vjs-play-progress:before {\n  display: none\n}\n\n.vjs-theme-forest .vjs-progress-holder {\n  border-radius: .2em;\n  height: .5em;\n  margin: 0\n}\n\n.vjs-theme-forest .vjs-load-progress, .vjs-theme-forest .vjs-load-progress div, .vjs-theme-forest .vjs-play-progress {\n  border-radius: .2em\n}\n\n.video-js .vjs-time-control {\n  display: block;\n}\n.video-js .vjs-remaining-time {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
